<template>
  <section>
    <HelpPage :axData="contentData" />
  </section>
</template>

<script>
import HelpPage from '@/components/common/HelpPage.vue';

export default {
  name: 'costs',
  components: {
    HelpPage,
  },
  data() {
    return {
      contentData: {
        title: '国内标准(单位/天)',
        tableDate: {
          column: ['费用项', '一线城市', '其他城市'],
          data: [['住宿费', '￥500', '￥400'], ['综合补助', '￥220', '￥220']],
        },
        promptData: [
          '一线城市为：北京、上海、广州、深圳。',
          '综合补助包含：差旅期间打车、工作餐、洗衣费、通讯费。综合补助不需要提供发票。',
        ],
      },
    };
  },
};
</script>
